import { render } from "./DialogModal.vue?vue&type=template&id=69dd6574&scoped=true"
import script from "./DialogModal.vue?vue&type=script&lang=js"
export * from "./DialogModal.vue?vue&type=script&lang=js"

import "./DialogModal.vue?vue&type=style&index=0&id=69dd6574&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69dd6574"]])

export default __exports__